import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const expandingVideoElem = document.querySelector('.expanding-video-modal');

if (expandingVideoElem) {
	const mm = gsap.matchMedia();

	mm.add('(min-width: 992px)', () => {
		const headerHeight = getComputedStyle(document.documentElement).getPropertyValue(
			'--headerHeightFull'
		);

		const imageScale =
			document.body.clientWidth /
			document.querySelector('.expanding-video-modal').offsetWidth;

		const expandingTL = gsap.timeline({
			scrollTrigger: {
				trigger: '.expanding-video-modal',
				start: () => {
					let top = 'top';
					if (headerHeight) {
						const offsetTop =
							(window.innerHeight -
								document.querySelector('.expanding-video-modal').offsetHeight) /
							2;
						top = `-${offsetTop}`;
					}

					return `${top} top`;
				},
				end: '+=100% end',
				scrub: true,
				pin: true,
				invalidateOnRefresh: true,
			},
		});
		expandingTL.fromTo(
			'.expanding-video-modal',
			{ scale: 1 },
			{
				scale: imageScale,
				onUpdate() {
					if ('isStart' === this.vars.data || 'undefined' === typeof this.vars.parent) {
						return;
					}

					const extraHeight =
						document.querySelector('.expanding-video-modal').offsetHeight * imageScale -
						document.querySelector('.expanding-video-modal').offsetHeight;

					const extraSpacing = extraHeight * this.progress();
					const spacer = this.vars.parent.scrollTrigger.spacer;
					if (null !== spacer && null !== spacer.parentElement) {
						spacer.parentElement.style.paddingBottom = `${extraSpacing / 2}px`;
					}
				},
			}
		);

		if (window.reduceAnimations) {
			expandingTL.scrollTrigger.disable();
		}

		document.addEventListener('prefers-reduced-motion', (event) => {
			if (event.detail.reduceAnimations) {
				expandingTL.scrollTrigger.disable();
			} else {
				expandingTL.scrollTrigger.refresh();
				expandingTL.scrollTrigger.enable();
			}
		});
	});
}
